import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { storeToRefs } from 'pinia'
import { useBikeStore } from '@/store/bikeStore'
import { useMeasurementStore } from '@/store/measurementStore'
import { getBikeCategory } from '@/utils/utils'
import BikeSetup from '@/components/preview/common/BikeSetup.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'BikeSetupFinished',
  setup(__props) {

const bikeStore = useBikeStore()
const measurementStore = useMeasurementStore()

const { bikeData, bikeFinalSetup } = storeToRefs(bikeStore)
const { finalMeasurement } = storeToRefs(measurementStore)

return (_ctx: any,_cache: any) => {
  return (_unref(bikeFinalSetup))
    ? (_openBlock(), _createBlock(BikeSetup, {
        key: 0,
        "bike-category": 
      _unref(getBikeCategory)(_unref(bikeData)?.MAIN_BIKETYPE_NAME, _unref(bikeData)?.SUB_BIKETYPE_NAME)
    ,
        "crank-arm-length": _unref(finalMeasurement).crankset.active,
        "crank-arm-length-diff": 
      _unref(bikeData)?.CRANK_LENGTH
        ? _unref(bikeData)?.CRANK_LENGTH - _unref(bikeFinalSetup).setupResult?.CrankLength
        : 0
    ,
        "pedal-height": _unref(finalMeasurement).pedal.active.PEDAL_HEIGHT,
        "pedal-height-diff": 
      _unref(bikeData)?.PEDAL_HEIGHT
        ? _unref(bikeData).PEDAL_HEIGHT - _unref(bikeFinalSetup).setupResult?.PedalHeight
        : 0
    ,
        "saddle-handlebar-drop": _unref(bikeFinalSetup).setupResult?.HandlebarDrop,
        "saddle-handlebar-drop-diff": 
      _unref(bikeData)?.SF_SADDLE_HANDLEBAR_DROP
        ? _unref(bikeData)?.SF_SADDLE_HANDLEBAR_DROP -
          _unref(bikeFinalSetup).setupResult?.HandlebarDrop
        : 0
    ,
        "saddle-height": _unref(bikeFinalSetup).setupResult?.SaddleHeight,
        "saddle-height-diff": 
      _unref(bikeData)?.SF_SADDLE_HEIGHT
        ? _unref(bikeData)?.SF_SADDLE_HEIGHT - _unref(bikeFinalSetup).setupResult?.SaddleHeight
        : 0
    ,
        "saddle-to-handlebar": _unref(bikeFinalSetup).SADDLE_HANDLEBAR_DISTANCE,
        "saddle-to-handlebar-diff": 
      _unref(bikeData)?.SF_SADDLE_HANDLEBAR_DISTANCE
        ? _unref(bikeData)?.SF_SADDLE_HANDLEBAR_DISTANCE -
          _unref(bikeFinalSetup).SADDLE_HANDLEBAR_DISTANCE
        : 0
    ,
        "saddle-width": 80,
        reach: _unref(bikeFinalSetup).setupResult?.FrameReach,
        stack: _unref(bikeFinalSetup).setupResult?.FrameStack
      }, null, 8, ["bike-category", "crank-arm-length", "crank-arm-length-diff", "pedal-height", "pedal-height-diff", "saddle-handlebar-drop", "saddle-handlebar-drop-diff", "saddle-height", "saddle-height-diff", "saddle-to-handlebar", "saddle-to-handlebar-diff", "reach", "stack"]))
    : _createCommentVNode("", true)
}
}

})